









































































































import { Component, Vue } from 'vue-property-decorator';
import { VueGoodTable } from '@folky-tools/vue-good-table';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { BusinessProspect } from '@/models/prospects/business-prospect';
import { usersService, axiosService } from '@/services';
import { mdbProgress, mdbTooltip, mdbIcon, mdbBtn } from '@folky-tools/mdbvue';
import Swal from 'sweetalert2';

@Component({
    components: {
        VueGoodTable,
        mdbProgress,
        mdbTooltip,
        mdbIcon,
        mdbBtn,
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class BusinessProspectsListView extends Vue {
    private rows: BusinessProspect[] = [];
    private columns: any[] = [];
    private totalRecords: number = 0;
    private rowsPerPage: number = 20;
    private isLoading: boolean = false;
    private showMoreInfo: boolean = false;
    private savingBasicData: boolean = false;
    private moreInfoData: BusinessProspect = new BusinessProspect();

    private serverParams: any = {
        columnFilters: {},
        sort: [
            {
                field: 'created',
                type: 'desc'
            }
        ],
        page: 1,
        perPage: this.rowsPerPage
    };

    private async beforeMount(): Promise<void> {
        await this.setColumns();
        await this.loadItems();
    }

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.prospects.businessProspectsListView.title');

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.BusinessProspects,
                scope: UserActionScopeType.List
            })
        );
    }

    private setColumns(): void {
        this.columns = [
            { field: 'id', type: 'number', sortable: false },
            { field: 'created', type: 'text', sortable: true },
            {
                field: 'businessTradeName',
                type: 'text',
                sortable: true,
                filterOptions: {
                    enabled: true,
                    placeholder: this.$t('common.placeholders.searchByName'),
                    filterValue: ''
                }
            },
            { field: 'companyTaxCode', type: 'text', sortable: false },
            { field: 'userFullName', type: 'text', sortable: false },
            { field: 'userEmail', type: 'text', sortable: false },
            { field: 'userPhone', type: 'text', sortable: false },
            { field: 'projectName', type: 'text', sortable: false },
            { field: 'actions-slot', type: 'text', sortable: false }
        ];
    }

    private async loadItems(): Promise<void> {
        this.isLoading = true;

        const response: any = await axiosService.instance.get('prospects/organization/businesses/query', {
            params: this.getQueryParams(this.serverParams.sort, this.serverParams.page, this.serverParams.perPage)
        });

        this.rows = [];

        this.totalRecords = response.data.count;
        response.data.items.forEach((item: any) => {
            this.rows.push(new BusinessProspect(item));
        });

        this.isLoading = false;
    }

    private getQueryParams(sortOrder: any, currentPage: number, perPage: number): any {
        return {
            $skip: (currentPage - 1) * perPage,
            $top: perPage,
            $orderby: this.getQueryOrderFromColumn(sortOrder),
            $filter: this.getQueryFilterFromColumns()
        };
    }

    private getQueryFilterFromColumns(): string | null {
        let queryFilter = '';
        const logicalOperatorBetweenFilters = ' and ';

        for (const key of Object.keys(this.serverParams.columnFilters)) {
            if (this.serverParams.columnFilters[key]) {
                if (key === 'businessTradeName') {
                    queryFilter += `${logicalOperatorBetweenFilters}contains(businessTradeName, '${this.serverParams.columnFilters[key].replace('\'', '\'\'')}')`;
                }
            }
        }

        return queryFilter === '' ? null : queryFilter.substring(logicalOperatorBetweenFilters.length);
    }

    private getQueryOrderFromColumn(sortOrder: any): string | null {
        if (sortOrder && sortOrder.length === 1) {
            if (sortOrder[0].field === 'created') {
                return `createdUtc ${sortOrder[0].type}`;
            } else {
                return `${sortOrder[0].field} ${sortOrder[0].type}`;
            }
        } else {
            return null;
        }
    }

    private async onPageChange(params: any): Promise<void> {
        this.updateParams({ page: params.currentPage });
        await this.loadItems();
    }

    private async onSortChange(params: any): Promise<void> {
        this.updateParams({
            sort: [
                {
                    type: params[0].type,
                    field: params[0].field
                }
            ]
        });
        await this.loadItems();
    }

    private async onColumnFilter(params: any): Promise<void> {
        this.serverParams.page = 1;
        this.updateParams(params);
        await this.loadItems();
    }

    private async onPerPageChange(params: any): Promise<void> {
        this.updateParams({ perPage: params.currentPerPage });
        await this.loadItems();
    }

    private updateParams(newProps: any): void {
        this.serverParams = { ...this.serverParams, ...newProps };
    }

    private async openMoreInfo(businessProspect: BusinessProspect): Promise<void> {
        await Swal.fire({
            title: this.$i18n.t('views.prospects.businessProspectsListView.moreInfo').toString(),
            html: businessProspect.toString(),
            type: 'info',
            showCancelButton: false,
            confirmButtonText: this.$i18n.t('common.actions.doClose').toString(),
            customClass: {
                confirmButton: 'btn btn-primary'
            },
            animation: false
        });
    }
}
